module.exports = __webpack_public_path__ + "assets/img/37_1012_big.426d508c.jpg";